import {
  SaveAgreementInput,
  UserAgreement
} from "../../../types/gqlTypes/graphql"
import { SAVE_AGREEMENT } from "./agreementMutations"
import { executeMutationSideload } from "../../generic-services/helpers/studyPlan"

export async function saveAgreement(
  data: SaveAgreementInput
): Promise<UserAgreement> {
  // A delayed automatic retry could use a different account's credentials.
  // The acceptance UI provides an explicit retry after a failed save.
  const response = await executeMutationSideload(SAVE_AGREEMENT, { data })
  return response.agreements.agreeToTerms
}
